import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Home from './pages/Home';
import PrivateRouter from './routers/PrivateRouter';

// Product
import ProductList from 'pages/product/ProductList';
import AddProduct from 'pages/product/AddProduct';
import UpdateProduct from 'pages/product/UpdateProduct';

// Team Message
import ListTeamMessage from 'pages/teammessage/ListTeamMessage';
import AddTeamMessage from 'pages/teammessage/AddTeamMessage';
import UpdateTeamMessage from 'pages/teammessage/UpdateTeamMessage';

// Enquire
import Enquire from 'pages/Enquire';

// Gallery
import GalleryList from 'pages/gallery/List';
import GalleryAdd from 'pages/gallery/Add';
import GalleryUpdate from 'pages/gallery/Update';

// Story
import StoryList from 'pages/story/List';
import StoryAdd from 'pages/story/Add';
import StoryUpdate from 'pages/story/Update';

// Media
import MediaList from 'pages/media/List';
import MediaAdd from 'pages/media/Add';
import MediaUpdate from 'pages/media/Update';

// News
import AddNews from './pages/ournews/AddNews';
import ListNews from './pages/ournews/ListNews';
import UpdateNews from './pages/ournews/UpdateNews';
import AddRepoter from './pages/repoters/AddRepoter';
import ListRepoters from './pages/repoters/ListRepoters';
import UpdateRepoter from './pages/repoters/UpdateRepoter';

// Contact
import Contactus from 'pages/Contactus';

function App() {
  return (
    <Router>
      <Routes>

        {/* ================= PUBLIC ROUTES ================= */}

        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Navigate to="/signin" replace />} />

        {/* ================= PRIVATE ROUTES ================= */}

        <Route element={<PrivateRouter />}>

          <Route path="/dashboard" element={<Home />} />
          <Route path="/contactus" element={<Contactus />} />

          {/* PRODUCT */}
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/update/:id" element={<UpdateProduct />} />

          {/* GALLERY */}
          <Route path="/gallery" element={<GalleryList />} />
          <Route path="/gallery/add" element={<GalleryAdd />} />
          <Route path="/gallery/update/:id" element={<GalleryUpdate />} />

          {/* STORY */}
          <Route path="/story" element={<StoryList />} />
          <Route path="/story/add" element={<StoryAdd />} />
          <Route path="/story/update/:id" element={<StoryUpdate />} />

          {/* MEDIA */}
          <Route path="/media" element={<MediaList />} />
          <Route path="/media/add" element={<MediaAdd />} />
          <Route path="/media/update/:id" element={<MediaUpdate />} />

          {/* TEAM MESSAGE */}
          <Route path="/team-message/list" element={<ListTeamMessage />} />
          <Route path="/team-message/add" element={<AddTeamMessage />} />
          <Route path="/team-message/update/:id" element={<UpdateTeamMessage />} />

          {/* ENQUIRE */}
          <Route path="/enquire" element={<Enquire />} />

          {/* NEWS */}
          <Route path="/ournews" element={<ListNews />} />
          <Route path="/ournews/add" element={<AddNews />} />
          <Route path="/ournews/update/:id" element={<UpdateNews />} />

          {/* REPOTERS */}
          <Route path="/repoters" element={<ListRepoters />} />
          <Route path="/repoters/add" element={<AddRepoter />} />
          <Route path="/repoters/update/:id" element={<UpdateRepoter />} />

        </Route>

        {/* ================= FALLBACK ================= */}

        <Route path="*" element={<h1>No page available</h1>} />

      </Routes>
    </Router>
  );
}

export default App;
